import { GlobalToken } from 'antd/es/theme/interface';
import { CEControl, OrgLevel, BPRCProcess } from 'store/ducks/Reporting/types';
import * as Styled from '../BusinessProcessTree.styled';
import { InfoButton } from './InfoButton';

const ORG_LABELS: Record<OrgLevel, string> = {
  group: 'GROUP',
  division: 'DIVISION',
  region: 'REGION',
  legal_entity: 'LEGAL ENTITY',
  business_unit: 'BUSINESS UNIT'
};

const ORG_LEVELS: OrgLevel[] = [
  'group',
  'division',
  'region',
  'legal_entity',
  'business_unit'
];

export const renderOrgNode = (
  name: string,
  level: OrgLevel,
  token: GlobalToken
): React.ReactNode => (
  <Styled.TreeNodeWrapper level={ORG_LEVELS.indexOf(level)}>
    <Styled.TreeLabel token={token}>{ORG_LABELS[level]}</Styled.TreeLabel>
    <Styled.TreeValue token={token} level={ORG_LEVELS.indexOf(level)}>
      {name}
    </Styled.TreeValue>
  </Styled.TreeNodeWrapper>
);

export const renderControlNode = (
  control: CEControl,
  token: GlobalToken
): React.ReactNode => (
  <Styled.TreeNodeWrapper level={5}>
    <Styled.TreeLabel token={token}>CONTROL</Styled.TreeLabel>
    <Styled.TreeValue token={token} level={5}>
      {control.control_name}
      <InfoButton type='controlEffectiveness' item={control} />
    </Styled.TreeValue>
  </Styled.TreeNodeWrapper>
);

export const renderProcessNode = (
  process: BPRCProcess,
  token: GlobalToken
): React.ReactNode => (
  <Styled.TreeNodeWrapper level={5}>
    <Styled.TreeLabel token={token}>PROCESS</Styled.TreeLabel>
    <Styled.TreeValue token={token} level={5}>
      {process.title}
    </Styled.TreeValue>
  </Styled.TreeNodeWrapper>
);

export const renderRiskNode = (
  title: string | null,
  token: GlobalToken
): React.ReactNode => (
  <Styled.TreeNodeWrapper level={6}>
    <Styled.TreeLabel token={token}>RISK</Styled.TreeLabel>
    <Styled.TreeValue token={token} level={6}>
      {title ?? '-'}
    </Styled.TreeValue>
  </Styled.TreeNodeWrapper>
);

export const renderProcessControlNode = (
  name: string | null,
  token: GlobalToken
): React.ReactNode => (
  <Styled.TreeNodeWrapper level={7}>
    <Styled.TreeLabel token={token}>CONTROL</Styled.TreeLabel>
    <Styled.TreeValue token={token} level={7}>
      {name ?? '-'}
    </Styled.TreeValue>
  </Styled.TreeNodeWrapper>
);
